import { SelectWrapper } from './styled'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faAngleDown, faInfo, faMagnifyingGlass, faWarning, faXmark } from '@fortawesome/free-solid-svg-icons'
import { removerAcentos, removerEspacos } from '../../../utils'
import { useEffect, useState, useRef } from 'react'
import { ItemList } from './components/item'
import Carregando from '../loading'
import Svg from '../../talhasvg'
import { Empty, Tooltip } from 'antd'
import { AnimationControls, Target, TargetAndTransition, VariantLabels } from 'framer-motion'

//PROPS
interface Props {
    label?: string
    placeholder?: string
    value: string
    onChange: React.Dispatch<React.SetStateAction<string>>
    onFocus?: Function;
    // onFocus?: (e: React.FocusEvent<HTMLInputElement>, name: string) => void;
    onChangeImage?:React.Dispatch<React.SetStateAction<string>>
    onChangeID?: React.Dispatch<React.SetStateAction<number | null>>
    onChangeExtra?: React.Dispatch<React.SetStateAction<number | string | null>> | Function
    icon?: any
    open: boolean
    trigger: React.Dispatch<React.SetStateAction<boolean>>
    children?: React.ReactNode
    maxHeight?: number | string
    items: any[]
    descricaoItem: string
    idItem: string
    componetItem?: string
    hasTalhaoSVG?: boolean;
    extraItem?: string | string[]
    multiextraItem?: string[]
    loading?: boolean
    disabled?: boolean
    task?: Function
    atual?: string
    disabledItens?: number[]
    id?: string
    allowClear?: boolean
    width?: number | string
    obrigatorio?: boolean;
    opcional?: boolean;
    /**Tamanho do SVG em `px` ([default: `30`]) */
    iconSVGSize?: number;
    talhaoSvgPath?: string[];
    node?: React.ReactNode
    refProp?: React.Ref<HTMLInputElement> 
    onClear?: Function;
    error?: boolean
    errorMessage?: string;
    initial?: boolean | Target | VariantLabels;
    animate?: AnimationControls | TargetAndTransition | VariantLabels | boolean;
    exit?: TargetAndTransition | VariantLabels;
    info_message?: string;
}

export const Select: React.FC<Props> = ({ label, placeholder, open, trigger, value, onChange, onFocus, onChangeImage,  maxHeight, items, 
    descricaoItem, icon, onChangeID, idItem, componetItem ,loading, disabled, task,  atual,  disabledItens, extraItem, onChangeExtra, 
    id, allowClear, width, obrigatorio, hasTalhaoSVG, iconSVGSize, opcional, talhaoSvgPath, multiextraItem, node, refProp, onClear, 
    error, errorMessage, initial = false, animate=false, exit=undefined, info_message }) => {
    //REF
    const refSelect = useRef<any>(null)

    //STATES
    const [buscar, setBuscar] = useState<string>('')
    const [indexSelecionado, setIndexSelecionado] = useState<number>(-1);
    const [index_atual, setIndex_atual] = useState<number>(null);


    const handleKeyDown = (e) => {
        if (open) {
            if (e.key === 'ArrowDown') {
                setIndexSelecionado((prevIndex) => (prevIndex + 1) % items?.length)
            } else if (e.key === 'ArrowUp') {
                setIndexSelecionado((prevIndex) => (prevIndex === 0 ? items.length - 1 : prevIndex - 1))
            } else if (e.key === 'Enter') {
                trigger(false)
            }
        }
    }

    function limpar() {
        onChange?.('')
        onChangeID?.(null)
        trigger?.(false)
    }

    const handleClickOutside: any = (event: React.MouseEvent<HTMLButtonElement>) => {
        if (refSelect.current && !refSelect.current.contains(event.target)) {
            trigger(false)
        }
    };

    function obterCaminhoSvg(item: any[]) {
        let caminho = !!talhaoSvgPath ? talhaoSvgPath : ['kml', 'coordenadas'];

        if (caminho.length === 1) {
            return item?.[caminho?.[0]]
        }
        if (caminho.length === 2) {
            return item?.[caminho?.[0]]?.[caminho?.[1]]
        }
        if (caminho.length === 3) {
            return item?.[caminho?.[0]]?.[caminho?.[1]]?.[caminho?.[2]]
        }
        if (caminho.length === 4) {
            return item?.[caminho?.[0]]?.[caminho?.[1]]?.[caminho?.[2]]?.[caminho?.[3]]
        }
        if (caminho.length === 5) {
            return item?.[caminho?.[0]]?.[caminho?.[1]]?.[caminho?.[2]]?.[caminho?.[3]]?.[caminho?.[4]]
        }

        return item?.['kml']?.['coordenadas']
    }

    function obterExtraItem(item: any[]) {
        
        if (typeof extraItem === 'string') {
            return item?.[extraItem];
        }

        if (Array.isArray(extraItem)) {
            return extraItem.map((key) => item?.[key]);
        }
     
    }

    useEffect(() => {
        document.addEventListener('click', handleClickOutside, true)
        return () => {
            document.removeEventListener('click', handleClickOutside, true)
        }
    })

    function encontrarAtivo(buscar_nome: string) {
        const ativoSemAcentos = removerAcentos(buscar_nome)
        return function (item) {
            const nomeSemAcentos = removerAcentos(String(item?.[descricaoItem]))
            return nomeSemAcentos.toLowerCase().includes(ativoSemAcentos.toLowerCase()) || !buscar_nome
        }
    }

    function info() {
        
        if(!info_message) return null;

        return (
            <Tooltip title={info_message}>
                <span style={{marginTop:-2,background:'var(--text-color-light)',color:'white',fontSize:10,width:15,height:15,borderRadius:'100%',display:'flex',justifyContent:'center',alignItems:'center'}}>
                    <FontAwesomeIcon icon={faInfo} />
                </span>
            </Tooltip>
        )
    }

    return (
        <SelectWrapper 
            style={{ width: width }} 
            
            data-disabled={disabled}
            initial={initial}
            animate={animate}
            exit={exit}
            transition={{duration: 1, ease: [0, 0.71, 0.2, 1.01], exit: { duration: 0.1, ease: [0, 1.21, 0.77, 0.91], delay: 0 } }}
        >
            {!!label && <label htmlFor={`select_${removerEspacos(placeholder)}`}>{label} {obrigatorio ? <span className="InputWrapper__obrigatorio">(obrigatório)</span> : (opcional ? <span className="InputWrapper__obrigatorio">(opcional)</span> : null)} {info()}</label>}

            <div
                className='SelectWrapper__campo'
                role='none'
                data-error={error}
                ref={refSelect} 
            // onClick={() => {
            //   trigger(true)
            // }}
            >
                {/* <FontAwesomeIcon icon={icon ?? faMagnifyingGlass} className='SelectWrapper__campo__icon' /> */}

                {(hasTalhaoSVG && index_atual !== null)
                    ? <Svg fill='#999999' coordinates={obterCaminhoSvg(items?.[index_atual ?? 0])} className='SelectWrapper__campo__icon_talhao' />
                    : <FontAwesomeIcon icon={(error ? faWarning : icon) ?? faMagnifyingGlass} className='SelectWrapper__campo__icon' />
                }

                <input
                    id={`select_${id ?? 'id'}_${removerEspacos(placeholder)}${Date.now()}`}
                    className='SelectWrapper__campo__input'
                    placeholder={placeholder}
                    onFocus={(e) => {
                        onFocus?.();
                        trigger(true)
                    }}
                    onKeyDown={handleKeyDown}
                    value={value}
                    onChange={(e) => {
                        onChange(e.currentTarget.value)
                        setBuscar(e.currentTarget.value)
                    }}
                    autoComplete='off'
                    // autoComplete="new-password"
                    disabled={disabled}
                    ref={refProp}
                />

                <div className='SelectWrapper__icons'>
                    {(value !== '' && allowClear !== false && disabled!==true) && (
                        <button className='SelectWrapper__campo__limpar' onClick={()=>{limpar();onClear?.()}} disabled={disabled}>
                            <FontAwesomeIcon icon={faXmark} />
                        </button>
                    )}
                    <button className='SelectWrapper__campo__arrow' disabled={disabled} onClick={(e) => { trigger(true) }}>
                        <FontAwesomeIcon icon={faAngleDown} />
                    </button>
                </div>
            </div>

            <div className={`SelectWrapper__lista`} data-open={open} data-haslabel={!!label} style={{ maxHeight: maxHeight }}>
                {loading && (
                    <div style={{ boxSizing: 'border-box', padding: '10px 20px', }}>
                        <Carregando legenda='buscando registros' direction='row' animation size='small' />
                    </div>
                )}

                {(items ?? []).filter(encontrarAtivo(buscar)).map((item, index) => {
                    return (
                        <ItemList
                            key={item?.[idItem]}
                            index={index}
                            focused={index === indexSelecionado}
                            onClick={() => {
                                onChange?.(item?.[descricaoItem]);
                                onChangeID?.(Number(item?.[idItem]));
                                onChangeImage?.(item?.[componetItem]);
                                onChangeExtra?.(obterExtraItem(item));
                                setIndex_atual?.(index);
                                trigger(false);
                                setBuscar('');
                                task?.()
                            }}
                            
                            current={atual}
                            disabled={disabledItens?.indexOf(Number(item?.[idItem])) > -1}
                            iconSVG={hasTalhaoSVG && obterCaminhoSvg(item)}
                            iconSVGSize={iconSVGSize}
                            node={item?.[componetItem]}
                        >
                            {item?.[descricaoItem]}
                        </ItemList>
                    )
                })}

                {(items?.length === 0 && !loading) && (
                    <Empty image={Empty.PRESENTED_IMAGE_SIMPLE} description={<>Nenhum registro disponível!</>} />
                )}

                {(items?.length > 0 && ((items ?? []).filter(encontrarAtivo(buscar))).length === 0 && !loading) && (
                    <Empty image={Empty.PRESENTED_IMAGE_SIMPLE} description={<> <b>'{value}'</b> não encontrado!</>} />
                )}

            </div>
            {error && <span className='SelectWrapper__error'>{errorMessage}</span>}
        </SelectWrapper>
    )
}
